import { Amount } from 'Shared/forms/Amount';
import { LabelOnLeftWrap } from 'Shared/forms/Wrap';
import { sizes } from 'Shared/backend/Theme';
import { StyleFieldsRow } from 'Shared/backend/styles/StyleFieldsRow';


/* A fluid fontSize ramps between these two container widths by default - the pair standardText() and
   the settings-page font-size leaf both use. */
const fluidSizeDefaults = {
	pageMin:  sizes().endFontShrink,
	minValue: 20,
	pageMax:  sizes().minDesktopWidth,
	maxValue: 40,
};


export function FontSize()
{
	return (
		<StyleFieldsRow>
			<FontSizeFields />
		</StyleFieldsRow>
	);
}


/* The size on its own, for a caller that names the location itself - see ruleProperties(). */
export function FontSizeFields()
{
	return (
		<LabelOnLeftWrap label='' narrow={true}>
			<Amount field='size' options={{px:'px', fluid:'fluid'}} fluidDefaults={fluidSizeDefaults} />
		</LabelOnLeftWrap>
	);
}
